import { $nodeSchema, $remark } from '@milkdown/kit/utils';
import remarkFountainScenes from './remark-fountain-scenes';

export const sceneNodeSpec = $nodeSchema('scene', () => ({
  group: 'block',
  content: 'block+',
  defining: true,
  attrs: {
    sceneHeadingText: { default: '' }
  },
  parseDOM: [
    {
      tag: 'div[data-fountain-scene="true"]',
      getAttrs: (dom) => {
        if (typeof dom === 'string') {
          return null;
        }
        return {
          sceneHeadingText: dom.getAttribute('data-scene-heading-text') || ''
        };
      }
    }
  ],
  toDOM: (node) => [
    'div',
    {
      class: 'scene',
      'data-scene-heading-text': node.attrs.sceneHeadingText
    },
    0
  ],
  parseMarkdown: {
    match: (node) => node.type === 'scene',
    runner: (state, node, type) => {
      state.openNode(type, { sceneHeadingText: node.value });
      state.next(node.children);
      state.closeNode();
    }
  },
  toMarkdown: {
    match: (node) => node.type.name === 'scene',
    runner: (state, node) => {
      state.addNode('scene', undefined, node.attrs.sceneHeadingText);
      state.next(node.content);
    }
  }
}));

export const milkdownFountainPlugin = [
  sceneNodeSpec,
  $remark('fountainScenes', () => remarkFountainScenes)
];
